import React, { useState, useEffect } from "react";
import { COLORS } from "constants/colors";
import { useToastsContext } from "contexts/toasts";

import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { deleteSubscriptionPackage } from "apis";
import { deletePackage } from "store/subscriptionPackagesSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/loader/index";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function DeleteSubscriptionPackage({
  open,
  handleClose,
  payload: id,
}) {
  const dispatch = useDispatch();
  const { packages } = useSelector((state) => state.subscriptionPackages);
  const { toggleToast } = useToastsContext();
  const [_open, set_open] = useState(false);
  const [spackage, setSPackage] = useState();
  const [loading, setLoading] = useState();

  const handleDeletePackage = async () => {
    setLoading(true);
    await deleteSubscriptionPackage({ id: spackage.id })
      .then((res) => {
        console.log(res);
        if (res?.data?.status === "fail") {
          toggleToast({
            type: "warning",
            msg: res?.data?.message,
          });
        } else {
          toggleToast({ 
            type: "success",
            msg: "Successfully Delete Subscription Package.",
          });
          dispatch(deletePackage(spackage));
          set_open(false);
          setSPackage({});
          handleClose();
        }
      })
      .catch((err) => {
        console.log(err);
        toggleToast({
          type: "error",
          msg: err.response.data.message || "Error Deleting Subscription Package.",
        });
      });

    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      const itemss = packages.filter((item) => item.id === id);
      setSPackage(itemss[0]);
    }
  }, [id]);

  useEffect(() => {
    set_open(open);
  }, [open]);

  // console.log(spackage);

  return (
    <>
      {open && (
        <Dialog
          open={_open}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          {spackage ? (
            <>
              <DialogContent sx={{ padding: "1rem", textAlign: "center" }}>
                <div className="min-w-[250px] sm:w-[400px] flex flex-col gap-5">
                  <div className="">
                    <WarningAmberIcon
                      sx={{ fontSize: "3rem", color: COLORS.danger }}
                    />
                  </div>
                  <Typography variant="h4">Are you sure?</Typography>

                  <Typography sx={{ opacity: "0.7" }}>
                    {`Are you Sure to delete the package "${spackage.package_name}"!`}
                  </Typography>
                </div>
              </DialogContent>
              <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  onClick={() => handleClose()}
                  size="large">
                  Cancel
                </Button>
                <LoadingButton
                  size="large"
                  sx={{ margin: "8px" }}
                  variant="contained"
                  loading={loading}
                  onClick={() => handleDeletePackage()}>
                  Delete
                </LoadingButton>
              </DialogActions>
            </>
          ) : (
            <Loader />
          )}
        </Dialog>
      )}
    </>
  );
}
